import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getLanguage } from 'api/utils/languageManagment';

import { getFaqLinks } from 'helpers/getFAQLinks';

import * as S from './styled';

const SubscriptionHelpButton = () => {
    const { t } = useTranslation();
    const lang = getLanguage();

    return (
        <S.HelpButton>
            <Text type="medium-text" bold>
                {t('subscription.helpButton.question')}
            </Text>
            <S.FaqLink
                href={getFaqLinks(lang)}
                data-locator="subscriptionFaqBtn"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Text type="caption" color="on-primary" bold>
                    {t('subscription.helpButton.faq')}
                </Text>
            </S.FaqLink>
        </S.HelpButton>
    );
};

export default SubscriptionHelpButton;
